import { DefaultExposeGroupEnum } from '@goparrot/common';
export const ServiceChargeExposeGroup = Object.freeze({ ...DefaultExposeGroupEnum });
//# sourceMappingURL=ServiceChargeExposeGroup.js.map